export const parseCommaNumbers = (str) =>
  (str || "")
    .split(",")
    .map((s) => s.replace(/\D/g, ""))
    .filter(item => item !== '');

export function applyGeographyParams(retObj, { geographyType, zipCodes, cbsaSelection, stateSelection, patientZip3s }) {
  switch (geographyType) {
    case "zipcode":
      retObj.parameters.zips = parseCommaNumbers(zipCodes);
      break;
    case "cbsa":
      retObj.parameters.cbsa = cbsaSelection && cbsaSelection.code ? cbsaSelection.code : '';
      break;
    case "state":
      retObj.parameters.state = stateSelection && stateSelection.value ? stateSelection.value : '';
      break;
    case "patientZip3":
      retObj.parameters.patientZip3s = parseCommaNumbers(patientZip3s);
      break;
    default:
      break;
  }
}


export function applyCommonOutputs(retObj, outputs, opts = {}) {
  const allow = opts.allowList ? new Set(opts.allowList) : null;
  const push = (key, label) => {
    if (allow && !allow.has(key)) return;
    if (outputs[key]) retObj.outputFields.push(label);
  };

  push('address', 'Address');
  push('city', 'City');
  push('stateName', 'State');
  push('county', 'County');
  push('zipCode', 'ZIP Code');
  push('distinctClaimsCount', 'Count of Distinct Claims');
  push('distinctPatientsCount', 'Count of Distinct Patients');
  push('proceduresCount', 'Count of Procedures');
  push('sumCharges', 'Sum of Charges');
  push('codeServiceLine', 'Code Service Line');
  push('codeDescription', 'Code Description');
  push('year', 'Year');
  push('month', 'Month');
  push('source', 'Source');
  push('sourceNpi', 'Source NPI');
  push('sourceName', 'Source Name');
  push('quarter', 'Quarter');
  push('name', 'Name');
  push('placeOfService', 'Place of Service');
  push('icd10Cm', 'ICD-10-CM');
  push('billingNpi', 'Billing NPI');
  push('billingName', 'Billing Name');
  push('billingClassification', 'Billing Classification');
  push('billingSpecialization', 'Billing Specialization');
  push('fipsCode', 'Patient FIPS County');
  push('fipsCountyName', 'Patient FIPS County Name');
  push('fipsState', 'Patient FIPS State');
}